import { render, staticRenderFns } from "./TypeOfExercise.vue?vue&type=template&id=4177227b"
import script from "./TypeOfExercise.vue?vue&type=script&lang=js"
export * from "./TypeOfExercise.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports